var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mainTitle",staticClass:"main-title",class:_vm.type},[_c('h1',{ref:"main"},[_vm._t("title")],2),(_vm.type === 'loader')?_c('h1',{ref:"progress",staticClass:"progress"},[_vm._t("title")],2):_c('h2',[_vm._t("subtitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }